import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

import { Space } from '@/components/base';
import Input from '@/components/Inputs/Input';
import PasswordInput from '@/components/Inputs/PasswordInput';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import service from '@/services';
import { connectionErrorHandler } from '@/services/integrations/util';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { isEmptyString } from '@/utils/util';

import { CompoundConnectModal } from '../../components/ConnectModal';
import type { ChanneltalkInfo } from '../types';

type Props = {
  onConnectComplete: (workspace: ChanneltalkInfo) => void;
};

export const ChanneltalkConnectModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [apiKey, setApiKey] = useState('');
  const [accessSecret, setAccessSecret] = useState('');
  const [error, setError] = useState<string | null>(null);
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);

  const handleConnectWorkspace = async () => {
    if (!currWorkspace) return;

    try {
      const data = await service.channeltalk.createChannelInfo(
        apiKey,
        accessSecret,
        currWorkspace.alias,
      );
      props.onConnectComplete(data);
      closeModal();
    } catch (e) {
      setError(connectionErrorHandler(e));
    }
  };

  const isApiKeyValid = !isEmptyString(apiKey) && !isEmptyString(accessSecret);

  return (
    <CompoundConnectModal
      title="Connect ChannelTalk"
      description="Access key and access secret are required to connect to ChannelTalk."
      error={error}
      connectButtonDisabled={!isApiKeyValid}
      handleConnectWorkspace={handleConnectWorkspace}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <Typo type="label2" weight="sb">
            Access key
          </Typo>
          <div
            className="flex items-center gap-1 cursor-pointer text-sm text-gray-600"
            onClick={() =>
              window.open('https://developers.channel.io/docs/authentication-2')
            }
          >
            How to get your Access key and Access secret
            <InfoCircleOutlined className="text-primary size-3.5" />
          </div>
          <Input
            placeholder="type access key"
            sizeType="m"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
          <Typo type="label2" weight="sb">
            Access secret
          </Typo>
          <Space h="12px" />
          <PasswordInput
            sizeType="m"
            placeholder="type access secret"
            name="accessSecret"
            value={accessSecret}
            onChange={(e) => setAccessSecret(e.target.value)}
          />
        </div>
      </div>
    </CompoundConnectModal>
  );
};
